module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point1_4-48ee9a755f696875a6d76746963116a1.jpg";